const NZShipping = () => {
  return (
    <>
      <div className="py-[55px] bg-[#000000]">
        <div className="md:max-w-[80%] max-w-full mx-auto py-[30px]">
          <div className="custom-container px-[30px] text-center">
            <div className="pt-[5px] pb-[8px]">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-8 gap-4">
                <div className="col-span-1 py-[2%]">
                  <h3 className="kuunari-bold text-center text-[#fff] text-[30px] pt-[3px] pb-[13px]">Shipping</h3>
                  <p className="montserrat-medium text-[16px] leading-[24px] text-[#fff]">
                    We can arrange freight by sea and/or land to most countries on request.
                  </p>
                </div>
                <div className="col-span-1 py-[2%]">
                  <h3 className="kuunari-bold text-center text-[#fff] text-[30px] pt-[3px] pb-[13px]">
                    Maintenance & Service
                  </h3>
                  <p className="montserrat-medium text-[16px] leading-[24px] text-[#fff]">
                    The Tuatara ATV is designed for easy repair and servicing by the owner or at the
                    local garage.
                  </p>
                </div>
              </div>
              <div className="py-[2%] max-w-[565px] mx-auto">
                <h3 className="kuunari-bold text-center text-[#fff] text-[30px] pt-[3px] pb-[13px]">
                  ATV/UTV Service Providers and Dealers
                </h3>
                <p className="montserrat-medium text-[16px] leading-[24px] text-[#fff] mx-auto">
                  Enquire now about opportunities to become a service provider or distributor of Tuatara ATVs and
                  accessories. If you are interested in joining the Tuatara team with their market-leading farm and
                  commercial side-by-sides, both petrol and electric models, make the enquiry now!
                </p>
              </div>
              <div className="text-center mt-8">
                <a
                  href="/nz/ContactUs"
                  className="bg-[#6FBF4A] text-white px-6 py-3 font-semibold uppercase hover:opacity-90 transition"
                >
                  Contact Us
                </a>
              </div>

            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default NZShipping;
